export const board = [
  {
    name: "Katherine Livingstone",
    title: "President",
  },
  {
    name: "Tom Goldie",
    title: "Past President",
  },
  {
    name: "Steve Kartonchik",
    title: "Vice President",
  },
  {
    name: "Ralph Button",
    title: "Secretary",
  },
  {
    name: "Denise Provencher",
    title: "Treasurer",
  },
  {
    name: "Peter Wehmeyer",
    title: "Director",
  },
  {
    name: "Dan Holstein",
    title: "Director",
  },
  {
    name: "Sony Poulose",
    title: "Director",
  },
  {
    name: "Yohana Otite",
    title: "Director",
  },
  {
    name: "Marlene Atlas",
    title: "Director",
  },
  {
    name: "Ann Higgins",
    title: "Director",
  },
  {
    name: "Paul Dowhaniuk",
    title: "Director",
  },
  {
    name: "Shubha Sandill",
    title: "Director",
  },
  {
    name: "Nick Davies",
    title: "Director",
  },
]
